import React from 'react';
import { connect } from 'react-redux';
import { BucketLayout, PageType } from 'enums';
import { createFetchPageAction } from 'page/actions';
import { fetchScheduleModule } from 'scheduleModule/actions';
import BannerAd from 'ads/BannerAd';
import Editorial from 'common/Editorial';
import InContentAd from 'ads/InContentAd';
import BucketListContainer from './buckets/BucketListContainer';
import MainContainer from './common/MainContainer';
import TopLayoutContainer from './common/TopLayoutContainer';

const Collection = (props) => {
    const { buckets = [] } = props;
    const bannerAd = [<BannerAd key="banner_ad" />];

    // layout will change depending on presence of editorial description, set some defaults
    let editorial = null;
    let inContentAd = null;
    let layoutOverride = BucketLayout.DEFAULT_UNLIMITED;
    let layoutClass = 'layout-full layout-full--watch';
    let columnClass = 'col-a';

    // if there is a description, show the ad and override to DEFAULT layout with unlimited items
    if (buckets[0] && buckets[0].description) {
        const header = `About ${buckets[0].name}`;
        const content = buckets[0].description;
        editorial = <Editorial header={header} content={content} />;
        inContentAd = <InContentAd exclude={['s', 'm']} />;
        layoutOverride = null;
        layoutClass = 'layout-bc layout-bc--watch';
        columnClass = 'col-b';
    }

    return (
        <MainContainer pre={bannerAd}>
            <TopLayoutContainer />
            <div className={layoutClass}>
                <section className={columnClass}>
                    <BucketListContainer
                        pageType={PageType.COLLECTION}
                        layoutOverride={layoutOverride}
                        key="bucket_list_container"
                    />
                </section>
                <section className="col-c">
                    {editorial}
                    {inContentAd}
                </section>
            </div>
        </MainContainer>
    );
};

Collection.propTypes = {
    buckets: React.PropTypes.array
};

Collection.loadActions = [
    (params, query, lang) => createFetchPageAction('collection', params, query, lang),
    (params, query, lang) => fetchScheduleModule(query, lang)
];

const mapStateToProps = (state) => ({
    buckets: (state.page && state.page.buckets) || []
});

export default connect(mapStateToProps)(Collection);



// WEBPACK FOOTER //
// ./app/page/Collection.js